<div class="eva-3-pricebox-cluster -responsive">
  <promotion-label *ngIf="!isDiscountByDeals && item.promotion" [promotion]="item.promotion">
    <coupon-coachmark
      *ngIf="hasCrossSellingCoachmark"
      id="coupon-coachmark"
      [product]="getProduct()"
      [position]="!isMobile() ? '-top -center' : '-top -right'"
      (closeEvent)="onCloseCoachmark()"
      [title]="coachmarkTitle"
      [description]="coachmarkDescription"
      [isActiveDiscountCookieName]="CROSS_SELLING_COUPON_COOKIE_NAME"
    >
    </coupon-coachmark>
  </promotion-label>
  <div class="pricebox-top-container">
    <div class="pricebox-value-container">
      <div class="pricebox-small-text" *ngIf="!showCartButton">
        <span>{{ serviceTypeText }}</span>
      </div>
      <div class="text-and-fav -eva-3-fwidth" *ngIf="showCartButton">
        <div class="pricebox-small-text">
          <span>{{ serviceTypeText }}</span>
        </div>
        <div class="favorite-container">
          <favorite-manager [item]="item" [cityGid]="cityGid"></favorite-manager>
        </div>
      </div>
      <div class="pricebox-value" *ngIf="showDualPriceLayout()">
        <div *ngIf="originalTotalPrice" class="pricebox-strikethrough-text">
          {{ getCurrencySymbol() }} {{ originalTotalPrice | priceFormatter }}
        </div>
        <span class="-eva-3-valign -eva-3-tc-brand-primary-3 -eva-3-mt-xsm eva-3-h4">
         {{ getCurrencySymbol() }} {{ getTotalPrice | priceFormatter }}
        </span>
       <div *ngIf="isRedemptionEnabled()" >
          <div class="price-separator"></div>
          <span class="eva-3-h6">{{ "cluster-pricebox.loyalty.redemption.pay" | translate }} {{ getCurrencySymbol() }} </span>
          <span class="eva-3-h4">
            {{ getTotalPriceWhenRedemptionIsEnabled() }}
          </span>
       </div>
      </div>

      <div class="pricebox-value" *ngIf="!showDualPriceLayout()">
        <div *ngIf="!isRedemptionEnabled() && originalTotalPrice" class="pricebox-strikethrough-text">
          <!--Aquí se debe mostrar el precio original sea funnel, cupon, etc-->
          {{ getCurrencySymbol() }} {{ originalTotalPrice | priceFormatter }}
        </div>
        <div *ngIf="isRedemptionEnabled() && originalTotalPriceWhenRedemptionIsEnabled" class="pricebox-strikethrough-text">
          {{ getCurrencySymbol() }} {{ originalTotalPriceWhenRedemptionIsEnabled }}
        </div>
        <span class="pricebox-currency">{{ getCurrencySymbol() }}</span>
        <span *ngIf="!isRedemptionEnabled()" class="pricebox-big-text">
          {{ getTotalPrice | priceFormatter }}
        </span>
        <span *ngIf="isRedemptionEnabled()" class="pricebox-big-text">
          {{ getTotalPriceWhenRedemptionIsEnabled() }}
        </span>
      </div>

      <!-- Disclaimer "pagando con ..."-->
      <div
        *ngIf="isDiscountByDeals && priceboxData?.payments"
        class ="payment-method"
      >
        <span class="pricebox-small-text">{{ "cluster-pricebox.discount.by.deal.disclaimer" | translate: {dealName: discountByDeals.paymentMethodsDescription} }}</span>
      </div>
      <div *ngIf="isRedemptionEnabled() && isDescriptionDefined()" [ngClass]="showDualPriceLayout() ? 'eva-3-subtitle-s -eva-3-tc-red-3 -eva-3-mb-xsm' : 'pricebox-small-text -loyalty-description -eva-3-tc-bubblegum-1'">
        {{ (showDualPriceLayout() ? "cluster-pricebox.loyalty.redemption.prefix.plus" : "cluster-pricebox.loyalty.redemption.prefix.using") | translate }} {{ item.loyalty.redemption.description }}
      </div>
      <div *ngIf="disclaimerText" class="eva-3-caption -eva-3-tc-gray-2">
        <span>{{ disclaimerText }}</span>
      </div>
      <div *ngIf="shouldShowNetPrice()" class="eva-3-caption -eva-3-tc-gray-2">
        {{ "cluster-pricebox.price.without.vat.text" | translate }}
        {{ getCurrencySymbol() }}
        {{ getNetPrice() | priceFormatter }}
      </div>
      <!-- Link "What does this price include?" -->
      <div *ngIf="isDiscountByDeals" class="see-details pricebox-small-text">
        <a class="eva-3-link " (click)="priceDetailModal.show()">{{ "cluster-pricebox.what.includes.price" | translate }}</a>
      </div>
    </div>
    <div class="pricebox-action" [ngClass]="{ 'pricebox-action-test': showCartButton }">
      <div class="favorite-container -eva-3-mr-sm" *ngIf="!showCartButton">
        <favorite-manager [item]="item" [cityGid]="cityGid"></favorite-manager>
      </div>
      <button
        *ngIf="!comesFromOffers"
        (click)="trackBuyEvt(); goToCheckout()"
        class="eva-3-btn -md -eva-3-fwidth -secondary"
        [ngClass]="{ '-loading': isLoading }"
      >
        <em class="btn-text">{{ "cluster-pricebox.buy" | translate }}</em>
        <span class="btn-status">{{
          "cluster-pricebox.loading" | translate
        }}</span>
      </button>
      <button
        *ngIf="comesFromOffers"
        (click)="fillSearchBoxData()"
        class="eva-3-btn -md -eva-3-fwidth -primary"
      >
        <em class="btn-text">{{ "cluster-pricebox.fill.data" | translate }}</em>
      </button>
      <div class="cart-container" *ngIf="showCartButton">
        <cart-manager
            [item]="item"
            [cityGid]="cityGid"
            [bookingCurrency]="bookingCurrency"
            class="eva-3-mt-sm -eva-3-fwidth">
        </cart-manager>
      </div>
    </div>
  </div>

  <agency-revenue-ribbon
    *ngIf="!!item.agency && !!(item.agency.revenue > -1)"
    [product]="getProduct()"
    [flow]="getFlow()"
    [locale]="getLocale()"
    [currencySymbol]="item.agency.currencySymbol"
    [thousandsSeparator]="getThousandSeparator()"
    [revenue]="item.agency.revenue"
    [commission]="item.agency.commission"
    [markup]="item.agency.markup"
    [commissionPercentage]="item.agency.commission_percentage"
    [markupPercentage]="item.agency.markup_percentage"
    [tooltipPosition]="'-left-inline'"
  >
  </agency-revenue-ribbon>

  <div
    *ngIf="loyaltyInfoMustBeRendered()"
    class="pricebox-loyalty-container eva-3-pricing-points"
  >
    <loyalty-info
      [loyaltyMode]="loyaltyMode"
      [points]="getPoints()"
      [pointsInRedemption]="getPoints()"
      [product]="getProduct()"
      [flow]="getFlow()"
      [locale]="locale"
      [mainMessageInColumn]="!isMobile()"
    ></loyalty-info>
  </div>

  <div
    class="pricebox-bottom-container"
    *ngIf="
      priceboxData.paymentPlan && priceboxData.paymentPlan.installments > 1
    "
  >
    <div class="installments">
      {{
        "cluster-pricebox.installments"
          | translate : { number: priceboxData.paymentPlan.installments }
      }}
    </div>
  </div>
  <div
    *ngIf="getScoringPoint() != null"
    class="-eva-3-bc-gray-4 -eva-3-p-sm -eva-3-haling"
  >
    <p class="-eva-3-p">
      {{ "cluster-pricebox.scoring" | translate }}
      <span class="-eva-3-bold"> {{ getScoringPoint() }}</span>
    </p>
  </div>
</div>
<price-detail-modal [price]="priceboxData.prices[this.currency]" [serviceTypeMessage]="serviceTypeText" [currencySymbol]="getCurrencySymbol()" [discountByDealEnabled]="isDiscountByDeals"  [discountByDealPaymentMethods]="discountByDeals?.paymentMethodsDescription" [loyaltyMode]="loyaltyMode" [redemptionDescription]="this.item.loyalty?.redemption?.description" [redemptionInfo]="this.item.loyalty?.redemption?.summary[this.currency]"></price-detail-modal>